module.exports = __webpack_public_path__ + "img/national-emblem.36896c09.png";